var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container" }, [
    _c("div", [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: _vm.$mq.phone
            ? "/static/img/survey/img_ironing_phone.jpg"
            : "/static/img/survey/img_ironing_web.jpg",
          alt: "..."
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "survey-ironing-table" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.formSubmit()
          }
        }
      },
      [
        _c("h4", [_vm._v("กรุณากรอกแบบสอบถามให้ครบทุกข้อ")]),
        _vm._v(" "),
        _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters pl-2" }, [
            _c(
              "div",
              { staticClass: "exp", class: _vm.$mq.phone ? "col-6" : "col-2" },
              [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.has_table,
                        expression: "form.has_table"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "has_table",
                      id: "have",
                      value: "มี"
                    },
                    domProps: { checked: _vm._q(_vm.form.has_table, "มี") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "has_table", "มี")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "exp", class: _vm.$mq.phone ? "col-6" : "col-2" },
              [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.has_table,
                        expression: "form.has_table"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "has_table",
                      id: "have_no",
                      value: "ไม่มี"
                    },
                    domProps: { checked: _vm._q(_vm.form.has_table, "ไม่มี") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "has_table", "ไม่มี")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm.errors.has("survey-ironing-table.has_table")
            ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n            "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.form.has_table == "มี"
          ? _c("div", [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters pl-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "exp",
                    class: _vm.$mq.phone ? "col-12" : "col-4"
                  },
                  [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.upload_img,
                            expression: "form.upload_img"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "upload_img",
                          id: "uploaded",
                          value: "มีรูปภาพในหน้าโปรไฟล์แล้ว"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.form.upload_img,
                            "มีรูปภาพในหน้าโปรไฟล์แล้ว"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "upload_img",
                              "มีรูปภาพในหน้าโปรไฟล์แล้ว"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(4)
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "exp",
                    class: _vm.$mq.phone ? "col-12" : "col-8"
                  },
                  [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.upload_img,
                            expression: "form.upload_img"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "upload_img",
                          id: "no_upload",
                          value: "ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.form.upload_img,
                            "ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "upload_img",
                              "ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.errors.has("survey-ironing-table.upload_img")
                ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.has_table == "ไม่มี"
          ? _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("สาเหตุ")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "select-jumbo",
                    style: _vm.$mq.phone ? "" : "width:40%"
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.causes,
                            expression: "form.causes"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "causes",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "ราคา ยังไม่สะดวกซื้อ" } },
                          [
                            _vm._v(
                              "\n                        ราคาสูง ยังไม่สะดวกซื้อ\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "หาซื้อไม่ได้" } }, [
                          _vm._v(
                            "\n                        หาซื้อไม่ได้\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "กำลังสั่งซื้อ" } }, [
                          _vm._v(
                            "\n                      กำลังสั่งซื้อ\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "ไม่สะดวกพกพา" } }, [
                          _vm._v(
                            "\n                        ไม่สะดวกพกพา\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "ไม่จำเป็นต่อการทำงาน" } },
                          [
                            _vm._v(
                              "\n                        ไม่จำเป็นต่อการทำงาน\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "อื่นๆ" } }, [
                          _vm._v(
                            "\n                        อื่นๆ\n                    "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.form.causes == "อื่นๆ"
                  ? [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.causes_other,
                            expression: "form.causes_other"
                          }
                        ],
                        staticClass: "form-control input-jumbo mt-2",
                        style: _vm.$mq.phone ? "" : "width:40%",
                        attrs: {
                          type: "text",
                          id: "causes_other",
                          name: "causes_other",
                          placeholder: "โปรดระบุ..."
                        },
                        domProps: { value: _vm.form.causes_other },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "causes_other",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "text-center pb-5" }, [
          _c(
            "button",
            {
              staticClass: "btn btn__submit btn-lg px-5 mt-3",
              attrs: { type: "submit", disabled: _vm.disableState }
            },
            [_vm._v("\n                Submit\n            ")]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "has_table" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("คุณแม่บ้านมีโต๊ะรีดผ้า หรือไม่")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "have" } }, [
      _c("span"),
      _vm._v("\n                        มี\n                      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-0", attrs: { for: "have_no" } }, [
      _c("span"),
      _vm._v("\n                        ไม่มี\n                      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "upload_img" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("คุณแม่บ้านมีโต๊ะรีดผ้า หรือไม่")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "uploaded" } }, [
      _c("span"),
      _vm._v(
        "\n                        มีรูปภาพในหน้าโปรไฟล์แล้ว\n                      "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-0", attrs: { for: "no_upload" } }, [
      _c("span"),
      _vm._v(
        "\n                        ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว\n                      "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2864a72d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2864a72d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/IronningTable.vue
// module id = 2423
// module chunks = 0